/**
 * 这里处理活动页面快速导航逻辑：
 * 1.上下滚动时实时激活对应导航（初始加载默认激活第一个导航项）；
 * 2.粘性定位生效时动态修改快速导航栏的z-index值（解决跟总导航菜单层级冲突问题）；
 */
const halloweenNav = document.querySelector('.halloween-sale-nav');// 获取粘性定位容器
const navItems = document.querySelectorAll('.halloween-sale-container .nav-item');// 获取所有导航项

// 滚动事件处理函数
function updateActiveNav() {
  let activeId = '';// 存储当前激活的区域id
  
  // 1.遍历每个导航项，判断对应区域是否在视口内
  navItems.forEach(item => {
    const targetId = item.getAttribute('href').slice(1);// 获取href中#后的id
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      const rect = targetElement.getBoundingClientRect();// 获取元素在视口的位置信息
      
      // 当元素顶部进入视口（距离顶部≤100px）且未完全离开视口时，视为当前区域
      // 100px可根据实际布局调整（例如导航栏高度）
      if (rect.top <= 100 && rect.bottom >= 0) {
        activeId = targetId;
      }
    }
  });

  // 如果没有任何区域被激活（初始加载时可能触发），默认激活第一个导航项
  if (!activeId && navItems.length > 0) {
    activeId = navItems[0].getAttribute('href').slice(1);
  }
  
  // 更新导航项的active状态
  navItems.forEach(item => {
    item.classList.remove('active');
    // 给当前激活区域对应的导航项添加active类
    if (item.getAttribute('href') === `#${activeId}`) {
      item.classList.add('active');
    }
  });

  // 2.检测 sticky 是否生效,随之更新它的z-index值
  if (halloweenNav) {
    // 获取导航栏在视口中的 top 位置（相对视口顶部的距离）
    const navViewportTop = halloweenNav.getBoundingClientRect().top;
    // 导航栏 sticky 设定的 top 值是 0，因此当视口 top <= 0 时，视为生效
    const isStickyActive = navViewportTop <= 20;

    // 根据 sticky 状态设置 z-index
    halloweenNav.style.zIndex = isStickyActive ? '11' : '9';
  }
}

window.addEventListener('scroll', updateActiveNav);// 监听滚动事件（页面滚动时触发）
updateActiveNav();// 初始加载时触发一次，设置默认状态